import { VendorsApi } from "@sb1finans/new-api/dist"
import { useCallback } from "react"
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'moment/locale/nb'
import { FC, useContext, useState } from "react";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import styled from "@emotion/styled"
import { AgreementContext } from "@sb1finans/components/dist/AgreementContext";
import LoadingButton from "@mui/lab/LoadingButton"
import moment, { Moment } from "moment";
import Alert from "@mui/material/Alert"
import Chip from "@mui/material/Chip"
import { useAgreementId } from "../hooks";
import { useParams } from "react-router-dom";

const PageContainer = styled(Paper)`
    max-width: 800px;
    margin: 0 auto;
    padding: 24px 16px;
`

const FormContainer = styled(Stack)`
    display: flex;
    width: 800px;
    padding-top: 24px;
`;

interface ReportsPageProps {
    agreementId: string,
    vendorsApi: VendorsApi
}

enum ReportType {
    Avregning, Kontoutdrag
}

export const ReportsPage: FC<ReportsPageProps> = ({agreementId: activeAgreementId, vendorsApi}) => {
    const [isLoadingReport, setIsLoadingReport] = useState(false)
    const [error, setError] = useState<Error | undefined>(undefined)
    
    const currentDate = new Date()
    const [startDate, setStartDate] = useState<Date | null>(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
    const [endDate, setEndDate] = useState<Date | null>(currentDate);

    const [selectedReportType, setSelectedReportType] = useState(ReportType.Avregning)

    console.log("startDate", startDate)
    console.log("endDate", endDate)

    function fetchReport() {
        setError(undefined)
        setIsLoadingReport(true)
        const type = selectedReportType == ReportType.Avregning ? "Avregning" : "Kontoutdrag"
        const fromDate = startDate && new Date(startDate.getTime() + Math.abs(startDate.getTimezoneOffset() * 60000)).toISOString().split("T")[0]
        if (fromDate === null) {
            setError(new Error("Fra dato er ikke gyldig."))
            return
        }
        const toDate = endDate && new Date(endDate.getTime() + Math.abs(endDate.getTimezoneOffset() * 60000)).toISOString().split("T")[0]
        if (toDate === null) {
            setError(new Error("Til dato er ikke gyldig."))
            return
        }

        vendorsApi.getReport(activeAgreementId!, fromDate, toDate, type, {timeout: 60000, responseType: "blob"})
            .then((res) => {
                const href = URL.createObjectURL(res.data as any)

                const link = document.createElement("a")
                link.href = href
                link.setAttribute("download", "report.xlsx")
                document.body.appendChild(link)
                link.click()

                document.body.removeChild(link)
                URL.revokeObjectURL(href)
                setIsLoadingReport(false)
            })
            .catch((err) => {
                console.error(err)
                setIsLoadingReport(false)
                setError(new Error("Kunne ikke lage rapport. Prøv igjen senere."))
            })
    }

    const onSelectReportType = (reportType: ReportType) => (event) => {
        console.log(reportType)
        console.log(event)
        setSelectedReportType(reportType)
    }

    return (
        <PageContainer variant="outlined">
            <Typography variant="h4" sx={{paddingBottom: 2}}>Last ned rapport</Typography>
            <Typography variant="body1">Her kan du laste ned avregningsrapporter. Velg periode og trykk last ned. Rapportene genereres i Excel-format.</Typography>
            <div style={{margin: "12px 0px"}}>
                <Chip 
                    label="Åpne poster" 
                    variant={selectedReportType == ReportType.Kontoutdrag ? "filled" : "outlined"} 
                    color="primary"
                    onClick={selectedReportType == ReportType.Kontoutdrag ? undefined : onSelectReportType(ReportType.Kontoutdrag)}
                    style={{marginRight: "12px"}}
                />
                <Chip 
                    label="Avregning" 
                    variant={selectedReportType == ReportType.Avregning ? "filled" : "outlined"} 
                    color="primary" 
                    onClick={selectedReportType == ReportType.Avregning ? undefined : onSelectReportType(ReportType.Avregning)}
                />
            </div>
            { error && <Alert severity="error">{error?.message}</Alert> }
            <FormContainer spacing={3} direction="row" justifyContent="flex-start" alignItems="baseline">
                <LocalizationProvider adapterLocale="nb" dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Fra dato"
                      minDate={moment("2022-07-01")}
                      disabled={selectedReportType == ReportType.Kontoutdrag}
                      value={startDate}
                      onChange={(newValue: unknown) => {
                        setStartDate((newValue as Moment).toDate());
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
                <Typography variant="body1" sx={{alignSelf: "center"}}>Til</Typography>
                <LocalizationProvider adapterLocale="nb" dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Til dato"
                      minDate={moment("2022-07-01")}
                      value={endDate}
                      disabled={selectedReportType == ReportType.Kontoutdrag}
                      inputFormat="DD-MM-YYYY"
                      onChange={(newValue: unknown) => {
                        console.log("NEW DATE IS: ", (newValue as Moment)?.toDate())
                        setEndDate((newValue as Moment).toDate());
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
                <LoadingButton loading={isLoadingReport} variant="contained" onClick={() => fetchReport()}>Last ned</LoadingButton>
            </FormContainer>
        </PageContainer>
    )
}